/* eslint-disable import/prefer-default-export */
import makeApiCall from './makeApiCall';

export const getMarketingMaterialAgendas = (params) =>
  makeApiCall(`/marketing_materials/agendas`, 'POST', params);

export const getMarketingMaterialPrograms = (params) =>
  makeApiCall(`/marketing_materials/programs`, 'POST', params);

export const getMarketingMaterialFiles = (params) =>
  makeApiCall(`/marketing_materials/files`, 'POST', params);

export const exportMarketingMaterialPrograms = (params) =>
  makeApiCall(`/marketing_materials/programs/export`, 'POST', params);

///
export const exportMaterialUtilization = (params) =>
  makeApiCall(`/materials/utilization/export`, 'POST', params);
